import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import './withTree.scss';

const EmptyIcon = () => (
  <IconButton aria-label="void" size="small" disabled>
    <div className="grb-empty-icon" style={{ width: '24px', height: '24px' }} />
  </IconButton>
);

const MemoizedEmptyIcon = React.memo(EmptyIcon);

const withTree = (CellComponent, options = {}) => {
  const { inc = 30 } = options;
  const { CollapsedIcon = KeyboardArrowRightIcon } = options;
  const { ExpandedIcon = KeyboardArrowDownIcon } = options;
  const { LeafIcon = MemoizedEmptyIcon } = options;
  // eslint-disable-next-line react/no-multi-comp
  class TreeCell extends React.PureComponent {
    static propTypes = {
      object: PropTypes.shape({}).isRequired,
      leaf: PropTypes.bool,
      treeDepth: PropTypes.number,
      collapsed: PropTypes.bool,
      tableHandler: PropTypes.shape({
        onToggleCollapse: PropTypes.func,
      }).isRequired,
    }

    static defaultProps = {
      leaf: true,
      treeDepth: 0,
      collapsed: false,
    }

    render() {
      const { leaf, treeDepth, collapsed, tableHandler } = this.props;
      const handleToggleCollapse = () => {
        tableHandler.onToggleCollapse(this.props.object);
      };
      const leftMargin = treeDepth * inc;
      const style = leftMargin ? { marginLeft: `${leftMargin}px` } : undefined;
      return (
        <div className={classnames('tuc-table-treecell', leaf && 'tuc-table-treecell-leaf', !leaf && (collapsed ? 'tuc-table-treecell-collapsed' : 'grb-table-treecell-expanded'))} style={style}>
          {!leaf ? (
            <IconButton aria-label="toggle" size="small" className="tuc-table-treecell-toggle" onClick={handleToggleCollapse}>
              {collapsed && <CollapsedIcon /> || <ExpandedIcon />}
            </IconButton>
          ) : (
            <LeafIcon />
          )}
          <CellComponent {...this.props} />
        </div>
      );
    }
  }

  return TreeCell;
};

export default withTree;
